// CUBE_VARIANT_STOCK is a Liquid-rendered map: { "variantId": { qty, tracked } }
// product | json strips inventory_quantity, so Liquid embeds it explicitly.
// JS-side filament guard: hides message immediately on load (no flash on cached
// non-filament pages), then re-shows only when confirmed filament (material template).

// Step 1 – hide synchronously so there is zero flash on cached pages
document.querySelectorAll('[id^="LowStockMessage-"]').forEach(function (el) {
  el.style.display = 'none';
});

var CUBE_FILAMENT_ALLOWED = false;

(function () {
  var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!pathMatch) return;
  // Use .json endpoint — only it exposes template_suffix
  fetch('/products/' + pathMatch[1] + '.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var suffix = data && data.product && data.product.template_suffix;
      if (suffix === 'material') {
        CUBE_FILAMENT_ALLOWED = true;
        // Step 2 – now run initial stock check for the currently selected variant
        var idInput = document.querySelector('input[name="id"]');
        if (idInput) updateLowStockMessageById(idInput.value);
      }
      // else: messages stay hidden (already done in Step 1)
    })
    .catch(function (err) {
      console.warn('[Cube] low-stock: product fetch failed', err);
    });
}());

function updateLowStockMessageById(variantId) {
  if (!CUBE_FILAMENT_ALLOWED) return;
  var stock = window.CUBE_VARIANT_STOCK && window.CUBE_VARIANT_STOCK[String(variantId)];

  document.querySelectorAll('[id^="LowStockMessage-"]').forEach(function (msgEl) {
    var sectionId = msgEl.id.replace('LowStockMessage-', '');
    var countEl = document.getElementById('LowStockCount-' + sectionId);
    var unitEl  = document.getElementById('LowStockUnit-'  + sectionId);
    if (!countEl) return;

    var qty = (stock && stock.tracked && typeof stock.qty === 'number') ? stock.qty : null;

    if (qty !== null && qty > 0 && qty <= 10) {
      countEl.textContent = qty;
      var u = stock.refill ? { one: 'refill', many: 'refills' } : (window.CUBE_STOCK_UNIT || { one: 'unit', many: 'units' });
      if (unitEl) unitEl.textContent = qty === 1 ? u.one : u.many;
      msgEl.style.display = '';
    } else {
      msgEl.style.display = 'none';
    }
  });
}

// Native Dawn option changes dispatch a 'change' event on input[name="id"].
// Swatch clicks call updateLowStockMessageById() directly from theme.liquid.
// This listener covers non-swatch variant changes (e.g., size/weight selectors).
document.addEventListener('change', function (e) {
  if (!e.target || e.target.name !== 'id') return;
  var variantId = String(e.target.value);
  if (!variantId || variantId === 'NaN') return;
  updateLowStockMessageById(variantId);
});
